// extracted by mini-css-extract-plugin
export default {"button-wrapper":"_7XUIK","buttonWrapper":"_7XUIK","dot":"_1UGET"};